<template>
  <div>
    <div class="title-dialog">
      <p style="font-size: 30px; font-family: Roboto; font-weight: 100;">{{$t('contact')}}</p>
    </div>
      
    <div class="icon-close">
      <b-icon stacked icon="x" @click="closeDialog()" scale="1.1" class="style-x" v-b-tooltip.hover title="Fechar" ></b-icon>
    </div> 

    <div class="wrapper-form">
      <b-form style="margin-bottom:0">
        <b-form-group label="Nome:">
          <b-form-input
          id="input-1"
          v-model="name"
          type="text"
          required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="E-mail">
          <b-form-input
          id="input-2"
          v-model="email"
          type="email"
          required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Assunto">
          <b-form-input
          id="input-3"
          v-model="subject"
          type="text"
          required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Mensagem" style="margin-bottom:0">
          <b-form-textarea
          id="textarea"
          v-model="mesage"
          rows="3"
          max-rows="3"
          ></b-form-textarea>
        </b-form-group>

      </b-form>

      <div>
        <b-button @click="sendEmail()" class="btn_1">
              {{$t('btn_send_email')}}
              <b-spinner  v-if="loadingSendingEmail" variant="light" small></b-spinner>
        </b-button>
      </div>
     
    </div>    
  </div>
</template>

<script>
import i18n from '@/i18n.js'
import {APIService} from '@/apiService';
const apiService = new APIService();

export default {
    data() {
        return {
            name: "",
            email:"",
            subject:"",
            mesage:"",

            loadingSendingEmail:false
           
        };
    },
    methods: {
      sendEmail(){
        this.loadingSendingEmail = true;
        var fieldsOk = true;
        if(this.name == '' || this.email == ''  || this.subject == '' || this.mesage == '') {
          this.$bvModal.msgBoxOk( i18n.t('message_error_fields_contact'), {
              modalClass:'modal-radius',
              title: 'Atenção',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'warning',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
          })
          fieldsOk = false;
          this.loadingSendingEmail = false;
        }

        if(fieldsOk){
          var email = {
            name: this.name,
            email:this.email,
            subject:this.subject,
            msg:this.mesage
          }
          apiService.sendEmail(apiService.objectToQuerystring(email)).then((data) => {
            this.loadingSendingEmail = false;

          this.$bvModal.msgBoxOk('Mensagem enviada com sucesso !!!', {
              title: 'Contato',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true,
          }).then(value => {
              console.log("vai fechar");
              this.closeDialog()
          })
          .catch(err => {
          // An error occurred
          })
            this.name = "",
            this.email = "",
            this.subject= "",
            this.mesage= ""
            
          })
        }

      },


      
      closeDialog: function(){
        console.log('fechar')
        this.$emit('showDialogContact', false )
      },
    }    
}
</script>

<style lang="scss" scoped>
 
  .wrapper-form{
    color: #fff;
    width: 435px;
    padding: 60px 20px 30px 20px;

    ::v-deep.form-control{
      padding: 0;
      font-size: inherit;
    }
    
    textarea.form-control{
      background-color: rgb(89, 111, 185);
      border: none;
      color: rgb(255, 255, 255);
      border-radius: 8px;
      padding-left: 9px;
      padding-top: 9px;
    }
        
  }
</style>
